@if (options) {
<google-map [height]="height" width="100%" [options]="options">
    @if (markerPosition) {
    <map-advanced-marker [position]="markerPosition" [options]="markerOptions" [content]="markerContent" class="rounded" />
    }
</google-map>
}